import { useMemo } from 'react';
import { NoticeExtractorFieldSourceResponseDto } from 'app/API';

type TProps = {
  sources?: Record<string, NoticeExtractorFieldSourceResponseDto[]>;
};

export function FieldSourcesCard({ sources }: TProps) {
  const entries = useMemo(() => Object.entries(sources ?? {}), [sources]);

  return (
    <section className="col-span-full min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Field sources</h3>
      {entries.length ? (
        <div className="grid max-h-[340px] gap-2.5 overflow-auto pr-1">
          {entries.flatMap(([fieldPath, fieldSources]) =>
            fieldSources.map((source, index) => (
              <div
                className="rounded-lg border border-border bg-surface-muted p-2.5"
                key={`${fieldPath}-${source.pageNumber}-${source.lineNumber}-${index}`}
              >
                <div className="mb-1.5 [overflow-wrap:anywhere] text-xs font-bold leading-[18px] text-accent">
                  {fieldPath} · page {source.pageNumber}, line {source.lineNumber}
                </div>
                <div className="whitespace-pre-wrap text-xs leading-[18px] text-foreground">{source.snippet}</div>
              </div>
            )),
          )}
        </div>
      ) : (
        <span className="text-xs leading-[18px] text-foreground-muted">No field source mapping returned</span>
      )}
    </section>
  );
}
